import React from "react";
import curveIcon from '../../images/icon-curve-arrow.svg';
import '../../sass/components/flexibleModules/_components.checkBoxTableFormatComponent.scss';

const CheckBoxTableFormatComponent = ({ data }) => {
    return (
        <div className="cp-checkBoxTableSection">
            <div className="cp-checkBoxTableSection__inner">
                <div className="cp-checkBoxTableSection__intro l--flex">
                    {data.checkboxTableFormatComponentHeader &&
                        <h2 dangerouslySetInnerHTML={{ __html: data.checkboxTableFormatComponentHeader }} />
                    }
                    {data.checkboxTableFormatComponentTeaser &&
                        <p dangerouslySetInnerHTML={{ __html: data.checkboxTableFormatComponentTeaser }} />
                    }
                </div>
                <div className="cp-checkBoxTableSection__table">
                    <div className="cp-checkBoxTableSection__table-section l--header l--flex">
                        <span></span>
                        <span>
                            <h3>Lightweight FP&A Tools</h3>
                            <p>that limit collaboration, are easily outgrown, and create inefficiency</p>
                        </span>
                        <span>
                            <h3>Planful</h3>
                            <p>an easy to use, finance-owned platform with fast time to value</p>
                        </span>
                        <span>
                            <h3>High Maintenance Systems</h3>
                            <p>difficult to learn, expensive to maintain, hurts user adoption</p>
                        </span>
                        <span className="l--absoluteCurveIcon">
                            <img src={curveIcon} alt="curve icon" />
                        </span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Not reliant on third partiers, IT or centre of excellence</span>
                        <span className="l--yes"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Flexible integrations and native connectors</span>
                        <span className="l--no"></span>
                        <span className="l--yes"></span>
                        <span className="l--yes"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Integrated Finance & Accounting solutions for end-to-end close, consolidation, planning, and reporting</span>
                        <span className="l--no"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Basic GenAI Capabilities</span>
                        <span className="l--yes"></span>
                        <span className="l--yes"></span>
                        <span className="l--yes"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Conversational AI with finance-specific ML for enriched insights</span>
                        <span className="l--no"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Fast implementation to get up and running in weeks, not months</span>
                        <span className="l--yes"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Purpose-built for departmental-wide planning needs</span>
                        <span className="l--no"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                    <div className="cp-checkBoxTableSection__table-section l--flex">
                        <span>Combines the ability to plan in spreadsheets with Excel syntax or in a dynamic online platform </span>
                        <span className="l--no"></span>
                        <span className="l--yes"></span>
                        <span className="l--no"></span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CheckBoxTableFormatComponent;